import * as React from 'react';
import { connect } from 'react-redux';
import {withRouter, IWithRouterProps} from '@utils/withRouterWrapper'
import './style.less';
import { Button } from 'telstra-ui/components/button/Button';
import BraintreeClientApi from '../../../../utils/braintree-apis/braintree-functions';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Application } from '../../';
import { ActivityTracking } from '@telstra-connect/billing';
import Routes from '../../route-constants';
import { IBillingAppState } from '@telstra-connect/billing/state';
import { State as LoginState } from '@telstra-connect/login';
import { IAddDebitcardDetailResponse } from '@telstra-connect/billing/state/add-debitcard-detail';
import { IUpdateDirectDebitDetailResponse } from '@telstra-connect/billing/state/update-direct-debit-details';
import { CreditCardFields } from './credit-card-fields';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import InlineLink from '@able/react/dist/InlineLink';
import TextStyle from '@able/react/dist/TextStyle';


interface ICreditCardProps {
    token: string;
    type?: string;
    isStaffUser: boolean;
    callPaymentApi?: (token) => void;
    showDisclaimer?: boolean;
    cancelClick?: () => void;
}

type ICreditCardState = IBillingAppState & LoginState.ISignInState;
interface ICreditCardOwnState {
    hostedFieldInstance: boolean;
    termsChk: boolean;
    submitBtnClick: boolean;
}
interface ICreditCardStateProps {
    addDebitcardDetail?: IAddDebitcardDetailResponse;
    updateDirectDebitDetail?: IUpdateDirectDebitDetailResponse;
}

type ICreditCardComponentProps =
    ICreditCardProps &
    ICreditCardStateProps & IWithRouterProps
class CreditCardFormComponent extends React.Component<ICreditCardComponentProps, ICreditCardOwnState> {
    private apiInstance ;
    public constructor(props) {
        super(props);
        this.apiInstance = new BraintreeClientApi({authorization: this.props.token});
        this.state = {
            hostedFieldInstance: false,
            termsChk: false,
            submitBtnClick: false
        }
    }
    public componentDidMount() {
        if (this.props.token) {
            this.apiInstance.setAuthorization(this.onClientInstanceCreation);
        }
    }
    public componentDidUpdate(prevProps: ICreditCardComponentProps) {
        if (this.props.type === 'UPDATE') {
            const isUpdated = (prevProps.updateDirectDebitDetail.status !== this.props.updateDirectDebitDetail.status) &&
                                (this.props.updateDirectDebitDetail.status === 'Success');
            if (isUpdated) {
                Application.tracker.trackLink(ActivityTracking.Components.setupDirectDebitForm,
                    ActivityTracking.Links.successfulCreditCardPayment);
            }
        } else {
            const isAdded = (prevProps.addDebitcardDetail?.status !== this.props.addDebitcardDetail?.status) &&
                                (this.props.addDebitcardDetail?.status === 'Success');
            if (isAdded) {
                Application.tracker.trackLink(ActivityTracking.Components.setupDirectDebitForm,
                    ActivityTracking.Links.successfulCreditCardPayment);
            }
        }
    }
    public cancelPayment = () => {
        this.props.type === 'PAY_NOW' ?
            Application.tracker.trackLink(ActivityTracking.Components.payByCreditCardForm,
                ActivityTracking.Links.creditCardFormCancel)
            :
            Application.tracker.trackLink(ActivityTracking.Components.setupDirectDebitForm,
                ActivityTracking.Links.cancelDirectDebit);
        this.props.navigate(-1);
    }
    public goToPaymentMethodPage = () => {
        this.props.cancelClick();
    }

    public checkTermsCondition = () => {
        this.setState({termsChk: !this.state.termsChk})

    }
    public captureDirectDebitAgreementOmniture = () => {
        Application.tracker.trackLink(ActivityTracking.Components.paymentOptions,
            ActivityTracking.Links.viewDirectDebitServiceAgreement);
        const navUrl = Application.routes.getPageSubpath(Routes.GetDirectDebitServiceAgreementRoute);
        window.open(navUrl, '_blank');
    }

    public checkSubmit = () => {
        if (this.props.type === 'UPDATE_DD') {
            this.setState({termsChk: true})
        }
        if (this.props.type === 'EDIT_PAYMENT_METHOD') {
            this.setState({termsChk: true})
        }
        this.setState({ submitBtnClick: true})
    }

    public showAlertBox = () => {
        Application.tracker.trackLink(ActivityTracking.Components.payByCreditCardForm,
            ActivityTracking.Links.creditCardFormContinue);
        this.setState({
            submitBtnClick: true
        })
        this.apiInstance.tokenizeMethod(this.props.callPaymentApi)
    }

    public render() {
        const termChkText =  'I agree with the terms and conditions of the direct debit service agreement.';
        const discText = this.props.type === 'ADD_PAYMENT_METHOD' ? 'We may offshore your' : 'We may offshore your credit or debit card'
        const link1 = "https://www.telstra.com.au/content/dam/shared-component-assets/";
        const disclaimerText = (
            <>{discText} payment information in accordance
            with our <a href="https://www.telstra.com.au/privacy#how-we-use"
                target="_blank" rel="noopener noreferrer" className="underline-privacy-link">Privacy Statement</a>
                &nbsp;and&nbsp;
            <a href={link1 + "tecom/campaigns/t-connect/Telstra%20Connect%20Terms%20and%20Conditions%20FINAL.pdf"}
                className="underline-privacy-link"
                target="_blank" rel="noopener noreferrer">Telstra Connect terms</a>.
            </>
        );
        return (
            <React.Fragment>
                <div className={ this.props.type === 'EDIT_PAYMENT_METHOD' && 'credit-card-left-padding'}>
                    <div className="bootstrap-basic">
                        <form className="needs-validation" id="payment_form">
                            {
                                <CreditCardFields cardType={this.props.type}/>
                            }
                        </form>
                        { this.props.type === 'SETUP_DD' &&
                        < React.Fragment >
                            <div className='term-text'>Terms</div>
                            <InlineLink>
                                <TextStyle alias="TextBodyShort" className='terms-agreement-text'><p>Please read the <a href="#" className="ddlink"
                                    onClick={this.captureDirectDebitAgreementOmniture}>
                                    {" direct debit service agreement (opens new tab) "}</a> and agree
																					to the terms and conditions.</p></TextStyle>
                            </InlineLink>
                            <div className='terms-agreement'>
                                <Checkbox
                                    id={"checkbox-state-1"}
                                    label={termChkText}
                                    name={'Name'}
                                    className={'tc-terms-agreement'}
                                    checked={this.state.termsChk}
                                    onChange={this.checkTermsCondition}
                                    required={this.state.submitBtnClick && !this.state.termsChk ? true : false}
                                    errorMessage={this.state.submitBtnClick && !this.state.termsChk ? "Please agree before you continue" : ""}
                                />
                            </div>
                        </React.Fragment>
                        }
                        { this.props.showDisclaimer &&
                        <div className="disclaimer">
                            <GenericAlert
                                name="primary-title"
                                description={disclaimerText}
                                showBackground={true}/>
                        </div>
                        }
                        <div className='cancel-submit-credit-card'>
                            <div className='cancel-button'>
                                {
                                    this.props.type === 'EDIT_PAYMENT_METHOD' ?
                                        <Button variant="secondary" size="medium" onClick={this.goToPaymentMethodPage}>
                                            {'Cancel'}
                                        </Button> : <Button variant="secondary" size="medium" onClick={this.cancelPayment}>
                                            {'Cancel'}
                                        </Button>

                                }
                            </div>
                            <div className='submit-button'>
                                <Button variant="super" size="medium"
                                    disabled={this.props.isStaffUser}
                                    onClick={this.props.type === 'PAY_NOW'
                                        ? () =>
                                            this.showAlertBox()
                                        : () =>  {
                                            this.checkSubmit(); this.apiInstance.tokenizeMethod(this.callTokenize)
                                        }}>
                                    {this.props.type === 'PAY_NOW' ? 'Continue' :
                                        this.props.type === 'ADD_PAYMENT_METHOD' ? 'Save' :
                                            this.props.type === 'EDIT_PAYMENT_METHOD' ? 'Update' : 'Submit'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
    private onInstanceCreation = () => {
        if (this.apiInstance.hostedFields) {
            this.setState({
                hostedFieldInstance: true
            })
        } else {
            // console.log('turn off');
        }
    }

    private onClientInstanceCreation = (clientInstance) => {
        this.apiInstance.getDatCollectorInstance(clientInstance);
        this.apiInstance.getHostedFieldsInstance(clientInstance, this.onInstanceCreation);
    }
    private callTokenize = (tokenPayload) => {
        if (tokenPayload && (this.state.termsChk || this.props.type === 'ADD_PAYMENT_METHOD'
        || this.props.type === 'EDIT_PAYMENT_METHOD')) {
            this.apiInstance.tokenizeMethod(this.props.callPaymentApi)
        }
    }
}

const mapStateToProps = (state: ICreditCardState):
ICreditCardStateProps => {
    return {
        addDebitcardDetail: state.billing?.addDebitcardDetail,
        updateDirectDebitDetail: state.billing?.updateDirectDebitDetail
    };
};
const CreditCardForm =
withRouter(connect<ICreditCardStateProps, {}, ICreditCardProps, ICreditCardState>
(mapStateToProps, null)(CreditCardFormComponent));

export default CreditCardForm;
